export const formatRegexes = {
  dashesLettersNumbers: /^([a-z]|-|\d)*$/i,
  dashesLettersNumbersSpaces: /^([a-z]|-|\s|\d)*$/i,
};
